import React from "react";
import { useLocation } from "react-router-dom";
import { Typography, Box } from "@mui/material";
import { COLORS } from "constants/colors";
import AppLayout from "works/chi/components/AppLayout";
import StyledButton from "works/chi/components/StyledButton";
import { createPayPayTicketQrCode } from "utils/api";

function ConfirmPayPay() {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);

  // クエリパラメータを取得
  const soulId = queryParams.get("soul_id");
  const episodeId = queryParams.get("episode_id");
  const ticketKey = queryParams.get("ticket_key");

  const [isDisabled, setIsDisabled] = React.useState(false);

  const handleRedirect = async () => {
    setIsDisabled(true);
    try {
      const { data } = await createPayPayTicketQrCode(
        soulId,
        episodeId,
        ticketKey
      );
      window.location.href = data.url;
    } catch (error) {
      console.error("Error creating PayPay QR code:", error);
      return;
    }
  };

  return (
    <AppLayout>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          width: "100%",
          minHeight: "100vh",
        }}
      >
        <Box
          sx={{
            width: "80%",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            backgroundColor: COLORS.BACKGROUND_WHITE,
            borderRadius: "5px",
            padding: 4,
            gap: 4,
          }}
        >
          {/* <Typography variant="h4" sx={{ fontSize: "15px", whiteSpace: "pre-line", fontWeight: "bold", textAlign: "center", color: COLORS.TEXT_BLACK, mt:1}}>
                {"PayPay購入時の注意"}
              </Typography> */}

          <Box>
            <Typography
              variant="h4"
              sx={{
                fontSize: "16px",
                whiteSpace: "pre-line",
                fontWeight: "bold",
                textAlign: "center",
                color: "#EB8010", // 落ち着いたオレンジ文字
                backgroundColor: "#FFF9EE", // 薄オレンジ背景
                border: "1px solid #FFD591", // 枠線もやさしめ
                borderRadius: "6px",
                padding: "10px 14px",
                lineHeight: "1.6",
                mt: 1,
              }}
            >
              PayPay決済が完了しても、LINEに戻るまでPayPayアプリを閉じずにそのままお待ちください。
            </Typography>
          </Box>

          <StyledButton
            variant="contained"
            sx={{
              width: "50%",
              fontSize: "17px",
              color: COLORS.TEXT_BLACK,
              border: `2px solid ${COLORS.TEXT_BLACK}`,
            }}
            onClick={handleRedirect}
            disabled={isDisabled}
          >
            購入する
          </StyledButton>
        </Box>
      </Box>

      {/* <Loading /> */}
    </AppLayout>
  );
}

export default ConfirmPayPay;
